import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';
import { ClientDetailsGetPdfStatementDownloadRequest } from 'bff/client';

export const useClientDetailsPdfStatementDownload = (
  request: ClientDetailsGetPdfStatementDownloadRequest,
  options?: UseMutationOptions<Blob, Error>
) => {
  const { clientDetailsApi } = useApiClient();

  return useMutation<Blob, Error, void>({
    ...options,
    mutationKey: ['clientDetailsPdfStatementDownload'],
    mutationFn: async () => {
      const timeout = 15000;

      return await Promise.race([
        clientDetailsApi.clientDetailsGetPdfStatementDownload(request),
        new Promise<Blob>((_, reject) =>
          setTimeout(() => reject(new Error('Timeout after 15 secs')), timeout)
        )
      ]);
    }
  });
};
